<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="cancel">Cancel</base-button>
          <base-button size="sm" type="neutral" @click="openNotesModal" v-if="$route.params.id">
            <span class="btn-inner--icon"><i class="fas fa-sticky-note"></i></span>
              <span class="btn-inner--text">Notes</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div class="text-right mb-3">
        <userpilot-flow :id="'1670602426iOxy9537'" :variant="'neutral'"></userpilot-flow>
      </div>
      <b-card no-body>
        <b-card-body>
          <validation-observer v-slot="{ invalid }" ref="formValidator">
            <form class="needs-validation" ref="dailyItemForm"
                  @submit.prevent="submit">
              <base-input label="Today's Date" label-for="date">
                <b-form-datepicker v-model="form.date" placeholder="Choose a date" local="en"></b-form-datepicker>
              </base-input>

              <b-row>
                <b-col md="4">
                  <base-input label="Hours Lead Generated:"
                              label-for="hours"
                              name="Hours Lead Generated"
                              type="number"
                              step="0.25"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.hours">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Dials Made:"
                              label-for="dials"
                              name="Dials Made"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.dials">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Contacts Made:"
                              label-for="contacts"
                              name="Contacts Made"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.contacts">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Listing Appointments Set:"
                              label-for="listings_set"
                              name="Listing Appointments Set"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.listings_set">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Listing Appointments Held:"
                              label-for="listings_held"
                              name="Listing Appointments Held"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.listings_held">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Listings Taken:"
                              label-for="listings_taken"
                              name="Listings Taken"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.listings_taken">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Listings Sold:"
                              label-for="listings_sold"
                              name="Listings Sold"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.listings_sold">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Listing Nurtures:"
                              label-for="listing_nurtures"
                              name="Listings Nurtured"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.listing_nurtures">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Buyer Appointments Set:"
                              label-for="buyers_set"
                              name="Buyer Appointments Set"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.buyers_set">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Buyer Appointments Held:"
                              label-for="buyers_held"
                              name="Buyer Appointments Held"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.buyers_held">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Buyers Signed:"
                              label-for="buyers_signed"
                              name="Buyers Signed"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.buyers_signed">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Buyers Sold:"
                              label-for="buyers_held"
                              name="Buyers Sold"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.buyers_sold">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Buyer Nurtures:"
                              label-for="buyer_nurtures"
                              name="Buyer Nurtures"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.buyer_nurtures">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Price Correction:"
                              label-for="price_correction"
                              name="Price Correction"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.price_correction">
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input label="Offers Written:"
                              label-for="offers_written"
                              name="Offers Written"
                              type="number"
                              step="1"
                              min="0"
                              rules="min_value:0|required"
                              v-model="form.offers_written">
                  </base-input>
                </b-col>
              </b-row>
              <div v-if="form.tracking_sources">
                <h3>Custom Categories</h3>
                <b-row>
                  <b-col md="4" v-for="source in form.tracking_sources" :key="source.id">
                    <base-input :label="source.label + ':'"
                                :label-for="source.label"
                                :name="source.label"
                                type="number"
                                step="0.25"
                                min="0"
                                rules="min_value:0|required"
                                v-model="source.value">
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <ul v-if="errorList" class="text-danger">
                <li v-for="(error, index) in errorList" :key="index">{{ error }}</li>
              </ul>

              <base-button block type="success" native-type="submit">Submit</base-button>
            </form>
          </validation-observer>
        </b-card-body>
      </b-card>
    </b-container>
    <notes-modal :type="'daily-items'"
                 :typeId="$route.params.id"
                 :userRoute="userRoute">
    </notes-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import initialState from './FormData/dailyItemsFormData.js';
import errorsMixin from '@/mixins/errors-mixin';
import NotesModal from '@/views/Components/Modals/NotesModal';
import UserpilotFlow from '@/views/Components/UserpilotFlow';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    NotesModal,
    UserpilotFlow
  },
  data() {
    return initialState();
  },
  computed: {
    backRoute() {
      if(this.$route.params.user) {
        return "/observatory/" + this.$route.params.user + "/daily-tracking";
      }
      return "/daily-tracking";
    },
    userRoute() {
      if(this.$route.params.user) {
        return process.env.VUE_APP_API_BASE_URL + "/users/" + this.$route.params.user;
      }
      return this.$store.getters['profile/userRoute'];
    },
    title() {
      if(this.form.id) {
        return "Edit Daily Tracking";
      }

      return "New Daily Tracking"
    }
  },
  methods: {
    async getDailyItem() {
      axios.get(this.userRoute + "/daily-items/" + this.$route.params.id)
      .then(response => {
        this.form = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getTrackingSources() {
      axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        response.data.forEach(source => {
          this.form.tracking_sources.push({
            label: source.name,
            id: source.id,
            value: 0
          });
        });
      })
      .catch(error => {
        this.error(error);
      })
    },
    async submit() {
      this.errorList = null;
      const isValid = await this.$refs.formValidator.validate();

      if(!isValid) {
        this.errorList = Object.values(this.$refs.formValidator.errors).flat();
      } else {
        if(this.form.id) {
          this.update();
        } else {
          this.add();
        }
      }
    },
    async add() {
      axios.post(this.userRoute + "/daily-items", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          Object.assign(this.$data, initialState());
          this.$refs.formValidator.reset();
          this.$router.push({
            path: this.backRoute
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async update() {
      axios.patch(this.userRoute + "/daily-items/" + this.form.id, this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          Object.assign(this.$data, initialState());
          this.$refs.formValidator.reset();
          this.$router.push({
            path: this.backRoute
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    cancel() {
      Object.assign(this.$data, initialState());
      this.$router.push({
        path: this.backRoute
      });
    },
    openNotesModal() {
      this.$bvModal.show('notes-modal');
    }
  },
  created() {
    if(this.$route.params.id) {
      this.getDailyItem();
    } else {
      this.getTrackingSources();
    }
  }
}
</script>
<style lang="scss">
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button {  
   opacity: 1;
}
</style>